import { useState } from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Button, Content, FloatInput, FormGroup, LoadingSpinner } from "@webtypen/react-components";
import { ApiHelper, AuthHelper } from "../helpers";
import logo from "../assets/logo.png";

const Wrapper = styled.div`
    width: 100%;
    max-width: 600px;
    margin: auto;
    flex: 1;
    display: flex;
`;

const Container = styled.div`
    flex: 1;
`;

export const Login = () => {
    const navigate = useNavigate();
    const auth = useSelector((state) => state.app.auth);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState(null);

    const submit = (e) => {
        e.preventDefault();

        const newErrors = {};
        if (!email || email.trim() === "") {
            newErrors["email"] = "Es muss eine E-Mail angegeben werden.";
        }

        if (!password || password.trim() === "") {
            newErrors["password"] = "Es muss ein Passwort angegeben werden.";
        }

        if (newErrors && Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        setIsLoading(true);
        ApiHelper.request("/api/auth/login", {
            email: email,
            password: password,
        })
            .then((response) => {
                if (
                    response.status === "success" &&
                    response.data &&
                    response.data.user &&
                    response.data.user._id &&
                    response.data.user.email &&
                    response.data.token
                ) {
                    AuthHelper.login(response.data.token, { ...response.data.user });
                    navigate("/dashboard");
                } else {
                    setErrors(
                        response.status === "error" && response.message
                            ? { email: response.message }
                            : { email: "Es ist ein unerwarteter Fehler aufgetreten." }
                    );
                    setIsLoading(false);
                }
            })
            .catch((e) => {
                console.error(e);
                setErrors(
                    e && e.data && e.data.status === "error" && e.data.message
                        ? { email: e.data.message }
                        : { email: "Es ist ein unerwarteter Fehler aufgetreten." }
                );
                setIsLoading(false);
            });
    };

    if (auth) {
        return <Navigate to="/dashboard" />;
    }

    return (
        <Wrapper>
            <Container>
                <Content>
                    <div className="text-center pr-3 pl-3">
                        <img
                            src={logo}
                            style={{ marginTop: 50, marginBottom: 50, height: "auto", width: "100%", maxWidth: 500 }}
                        />
                    </div>

                    <h1 className="mt-0 text-center">Login</h1>

                    <form onSubmit={submit}>
                        <FormGroup errors={errors} errorKey="email">
                            <FloatInput
                                type="email"
                                placeholder="E-Mail"
                                disabled={isLoading}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup errors={errors} errorKey="password">
                            <FloatInput
                                type="password"
                                placeholder="Passwort"
                                disabled={isLoading}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </FormGroup>

                        <div style={{ display: "flex" }}>
                            <div style={{ flex: 1 }}>
                                <Button disabled={isLoading}>{isLoading ? <LoadingSpinner /> : "Einloggen"}</Button>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "flex-end",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    display: "none",
                                }}
                            >
                                <Link to="/forgot-pw">Passwort vergessen</Link>
                            </div>
                        </div>
                    </form>
                </Content>
            </Container>
        </Wrapper>
    );
};
